<con-page-layout>
  <con-page-header header="Maintenance Schedule"></con-page-header>
  <con-page-layout-content>
    <div>
      <div class="filter">
        <mat-form-field class="filter__field" appearance="fill">
          <mat-label>Filter by Account Name</mat-label>
          <input matInput [(ngModel)]="accountFilter" />
        </mat-form-field>
      </div>
      <form #form="ngForm" novalidate>
        <mat-table class="lessons-table mat-elevation-z8" #table [dataSource]="filteredMaintenances$ | async">
          <ng-container matColumnDef="connectAccountName">
            <mat-header-cell *matHeaderCellDef>Account Name</mat-header-cell>
            <mat-cell *matCellDef="let row"
              ><a [routerLink]="[row.connectSolutionId, 'edit']" routerLinkActive="router-link-active">{{ row.connectAccountName }}</a></mat-cell
            >
          </ng-container>

          <ng-container matColumnDef="AUnique">
            <mat-header-cell *matHeaderCellDef>AUnique</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.aUnique }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="connectFolderName">
            <mat-header-cell *matHeaderCellDef>Folder Name</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.connectFolderName }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="connectFolderRegion">
            <mat-header-cell *matHeaderCellDef>Folder Region</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.connectFolderRegion }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceStartTime">
            <mat-header-cell *matHeaderCellDef>Maintenance Start Time</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.maintenanceStartTime }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceEndTime">
            <mat-header-cell *matHeaderCellDef>Maintenance End Time</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.maintenanceEndTime }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="maintenanceNotes">
            <mat-header-cell *matHeaderCellDef>Maintenance Notes</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.maintenanceNotes }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="remove">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <button *ngIf="row.maintenanceStartTime || row.maintenanceEndTime" mat-icon-button (click)="removeMaintenance(row.connectSolutionId)">
                <mat-icon [matTooltip]="removeTooltip">{{ removeIcon }}</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
        </mat-table>
      </form>
    </div>
    <div *ngIf="errorMessage$ | async as errorMessage">
      {{ errorMessage }}
    </div>
  </con-page-layout-content>
</con-page-layout>
